<template>
  <b-form style="min-width: 150px;" @submit.prevent>
    <b-form-group :label="placeHolder" label-for="icon-picker">
      <v-select
        :disabled="isDisabled"
        id="icon-picker"
        dir="rtl"
        :filterable="false"
        v-model="selectedIcon"
        :options="iconList"
        :reduce="(icon) => icon"
        placeholder="یک آیکون انتخاب کنید"
        :clearable="false"
      >
        <template #option="option">
          <div class="d-flex align-items-center">
            <span
              class="icon-picker-icon"
              :style="{
                backgroundColor: option.background,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '36px',
                height: '36px',
                borderRadius: '15px',
                marginLeft: '10px'
              }"
            >
              <img :src="require(`@/assets/images/icons/picker/${option.value}.svg`)" alt="icon" style="width:22px;height:22px;" />
            </span>
          </div>
        </template>
        <template #selected-option="option">
          <div class="d-flex align-items-center">
            <span
              class="icon-picker-icon"
              :style="{
                backgroundColor: option.background,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '28px',
                height: '28px',
                borderRadius: '15px',
                marginLeft: '8px'
              }"
            >
              <img :src="require(`@/assets/images/icons/picker/${option.value}.svg`)" alt="icon" style="width:16px;height:16px;" />
            </span>
          </div>
        </template>
        <template #no-options>هیچ آیکونی جهت انتخاب وجود ندارد</template>
      </v-select>
    </b-form-group>
  </b-form>
</template>

<script>
export default {
  emits: ['getIcon'],
  props: {
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeHolder: {
      type: [String, null],
      required: false,
      default: 'انتخاب آیکون مورد نظر',
    },
  },
  data() {
    return {
      // لیست استاتیک آیکون‌ها و رنگ‌ها
      iconList: [
        {
          value: 'badgeCheck',
          background: '#5ec576',
        },
        {
          value: 'bolt',
          background: '#ffd700',
        },
        {
          value: 'crown',
          background: '#f49837',
        },
        {
          value: 'gift',
          background: '#ff8a65',
        },
        {
          value: 'medal',
          background: '#00bcd4',
        },
        {
          value: 'receiptStar',
          background: '#e578e3',
        },
        {
          value: 'rocketLaunch',
          background: '#66bb6a',
        },
        {
          value: 'trophyStar',
          background: '#ef5350',
        },
      ],
      selectedIcon: null
    }
  },
  watch: {
    selectedIcon: {
      handler(val) {
        this.$emit('getIcon', JSON.stringify(val))
      }
    }
  },
  components: {
    BForm,
    BFormGroup,
    vSelect,
  },
};
import { BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
</script>
<style scoped>
.icon-picker-icon img {
  display: block;
}
</style>